module.exports = __webpack_public_path__ + "img/read-only-icon.1b6c91ed.png";